export const react18WorkaroundProps = {
  placeholder: undefined,
  onPointerEnterCapture: () => {},
  onPointerLeaveCapture: () => {}
};
